import {reduxMultiple} from '../../../reduxHelpers'

const {reducer, actions, saga} = reduxMultiple.HR.ABSENCE()
export {reducer, actions, saga}
